import { render } from "./switchSet.vue?vue&type=template&id=14913b5f"
import script from "./switchSet.vue?vue&type=script&lang=js"
export * from "./switchSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__